// src/supabaseClient.js

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// --- UPDATED: The redirect URL now points back to our dedicated auth callback page ---
const getRedirectUrl = () => {
  const url = window.location.origin + '/auth/callback';
  console.log('Redirect URL set to:', url);
  return url;
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    redirectTo: getRedirectUrl()
  }
});